import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getToken } from "./../../utils/utils";

export const fetchAboutUs = createAsyncThunk(
  "fetchAboutUs",
  async (data, thunkAPI) => {
    const url = process.env.REACT_APP_API_URL + "/controller/about_us/list.php";
    const authorization = getToken();
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data.about_us;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const fetchAboutUsSearch = createAsyncThunk(
  "fetchAboutUsSearch",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL +
      "/controller/about_us/search.php?search=" +
      data;
    const authorization = getToken();
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data.about_us;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const fetchAboutUsEdit = createAsyncThunk(
  "fetchAboutUsEdit",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL +
      "/controller/about_us/details.php?id=" +
      data.id;
    const authorization = getToken();
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data.about_us[0];
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const saveAboutUs = createAsyncThunk(
  "saveAboutUs",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL + "/controller/about_us/create.php";
    const authorization = getToken();
    const options = {
      method: "post",
      headers: {
        Authorization: "Bearer " + authorization,
        "Content-Type": "multipart/form-data",
      },
      url,
      data: data,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          if (result.data.about_us) return result.data.about_us;
          else return result.data.message;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const editAboutUs = createAsyncThunk(
  "editAboutUs",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL + "/controller/about_us/update.php";
    const authorization = getToken();
    const options = {
      method: "post",
      headers: {
        Authorization: "Bearer " + authorization,
        "Content-Type": "multipart/form-data",
      },
      url,
      data: data,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          if (result.data.about_us) return result.data.about_us;
          else return result.data.message;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const deleteAboutUs = createAsyncThunk(
  "deleteAboutUs",
  async (id, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL +
      "/controller/about_us/delete.php?id=" +
      id;
    const authorization = getToken();
    const options = {
      method: "delete",
      headers: { Authorization: "Bearer " + authorization },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.status) {
          return result.status;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);
